
  <b-table
      class="OrdersTable"
      checkable
      :is-row-checkable="isRowCheckable"
      :checked-rows.sync="checkedRows"
      hoverable
      paginated
      backend-pagination
      :data="orders"
      :columns="columns"
      :loading="isLoading"
      :empty="!isLoading && total === 0"
      :total="total"
      :per-page="perPage"
      backend-sorting
      default-sort-direction="desc"
      :default-sort="[sortParams.field, sortParams.order]"
      @page-change="changePage"
      @sort="changeSortParams"
      @update:checkedRows="$emit('update:checkedRows', $event)"
      @check="selectPermanentPoint"
  >
    <template slot-scope="props">
      <b-table-column field="id" :label="getLabel('id')">{{ props.row.id }}</b-table-column>

      <b-table-column field="name" :label="getLabel('name')">
        <a href @click.prevent="editPermanentPoint(props.row)">
          <span>{{ props.row.name }}</span>
        </a>
      </b-table-column>

      <b-table-column field="address" :label="getLabel('address')">
				<span v-if="props.row.lat && props.row.lon" class="address-marker">
					<i class="mdi">location_on</i>
				</span>
        <span v-html="getTableOrderAddress(props.row)"></span>
      </b-table-column>

      <b-table-column
          field="phone"
          :label="getLabel('phone')"
          class="nowrap"
          :visible=true
      >
        {{ props.row.phone }}
        <div v-if="props.row.scndPhone">{{ props.row.scndPhone }}</div>
      </b-table-column>


      <b-table-column
          field="createdDate"
          :label="getLabel('createdDate')"
          :visible="canSortByCreatedDate"
      >
        <div v-if="props.row.createdDate">
          {{ props.row.createdDate | humanDate }}
          <small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
        </div>
        <span v-else>-</span>
      </b-table-column>
    </template>

    <template slot-scope="props" slot="header">
      {{ props.column.label }}
      <i
          v-show="sortParams.field === props.column.field"
          :class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
      >arrow_upward</i
      >
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Brak zamówień.</p>
        </div>
      </section>
    </template>
    <!-- <template slot="bottom-left" v-if="orders.length">
      <b>Wybranych</b>: {{ checkedRows.length }}
    </template>-->
    <template slot="bottom-left">
      <div class="per-page">
        <span>Pokaż rekordów:</span>
        <b-select @input="changePerPage($event)" :value="perPage">
          <option
              v-for="(value, index) in perPageOptions"
              :key="index"
              :value="value"
              :selected="value === perPage"
          >
            {{ value }}
          </option>
        </b-select>
      </div>
    </template>
  </b-table>
